import React, { useCallback, useEffect, useRef, useState } from 'react'
import Table from '../components/Table';
import { useDispatch, useSelector } from 'react-redux';
import { PulseLoader } from 'react-spinners';
import { RegisterSupplierAPI } from '../redux/actions/Supplier/RegisterSupplierAction';
import { useLocation } from 'react-router-dom';
import { CitySelect, CountrySelect, StateSelect } from 'react-country-state-city/dist/cjs';
import PhoneInput from 'react-phone-input-2';
import { UsersListApi } from '../redux/actions/User/UserListAction';
import { showErrorToast, showSuccessToast } from '../helpers/SweetAlert';
import { registerSupplierStateReset } from '../redux/slices/Supplier/RegisterSupplierSlice';

const SupplierManagement = () => {
    const columns = [
        "Supplier Name",
        "Total Product",
        "Country",
        "Email",
        "Status",
        "Action",
    ]
    const dispatch = useDispatch()
    const location = useLocation();
    const modalRef = useRef(null);
    const [validationErrors, setValidationErrors] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [country, setCountry] = useState(null);
    const [countryName, setCountryName] = useState(null);
    const [state, setState] = useState(null);
    const [stateName, setStateName] = useState(null);
    const [streetAddress, setStreetAddress] = useState('');
    const [city, setCity] = useState(null);
    const [cityName, setCityName] = useState(null);
    const [zipCode, setZipCode] = useState('');
    const [productType, setProductType] = useState('');

    const [currentPage, setCurrentPage] = useState(1);

    const [totalPages, setTotalPages] = useState(1);
    const [items, setItems] = useState(5);

    const [limit, setLimit] = useState(5);

    const searchTerm = useSelector((state) => state.search.term);
    const statusTerm = useSelector((state) => state.status.term);
    const { loading: productTypeLoading, response: productTypeResponse, error: productTypeError } = useSelector((state) => state.getProductTypeRegister);
    const { loading: supplierRegisterationLoading, response: supplierRegisterationResponse, error: supplierRegisterationError } = useSelector((state) => state.registerSupplier);

    const { loading, response, error } = useSelector((state) => state.usersList);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchUsersList = useCallback(() => {
        let role;
        dispatch(UsersListApi(currentPage, limit, role = "supplier", searchTerm, statusTerm));
    }, [currentPage, limit, searchTerm, statusTerm, dispatch, location.pathname]);

    const clearForm = () => {
        setFirstName("");
        setLastName("");
        setPhoneNumber("");
        setEmail("");
        setCountry("");
        setCountryName("");
        setState("");
        setStateName("");
        setCity("");
        setCityName("");
        setStreetAddress("");
        setZipCode("");
        setProductType("");
        setValidationErrors({});
    };

    const handleAddNewSupplier = async () => {
        if (!validateForm()) {
            // Stop submission if validation fails
            return;
        }

        try {
            await dispatch(RegisterSupplierAPI({ role: 'supplier', firstName, lastName, email, phoneNumber, state: stateName, city: cityName, street: streetAddress, country: countryName, zipCode, registeredBy: 'Admin', product: productType }))
        } catch (error) {
            console.log(error, "Error")
        }
    };

    useEffect(() => {
        fetchUsersList();
    }, [currentPage, limit, statusTerm, searchTerm, fetchUsersList, supplierRegisterationResponse])

    console.log(response, "response")

    useEffect(() => {
        setCurrentPage(1);
    }, [location.pathname, statusTerm, searchTerm]);

    useEffect(() => {
        if (response?.status === true) {
            setTotalPages(response?.data?.totalPages);
            setCurrentPage(response?.data?.currentPage);
            setItems(response?.data?.totalItems)
        }
    }, [response])


    useEffect(() => {
        const modalElement = modalRef.current;

        if (modalElement) {
            // Add event listener for when modal hides
            modalElement.addEventListener("hidden.bs.modal", clearForm);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener("hidden.bs.modal", clearForm);
            }
        };
    }, []);

    const validateForm = () => {
        const newErrors = {};

        if (!firstName || firstName.trim() === '') newErrors.firstName = true;
        if (!lastName || lastName.trim() === '') newErrors.lastName = true;

        if (!phoneNumber || phoneNumber.length < 10) newErrors.phone = true;

        if (!email || email.trim() === '') {
            newErrors.email = "required";
        } else {
            // Regex to check valid email format
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                newErrors.email = "invalid";
            }
        }

        if (!country) newErrors.country = true;
        if (!state) newErrors.state = true;
        if (!city) newErrors.city = true;
        if (!streetAddress || streetAddress.trim() === '') newErrors.streetAddress = true;
        if (!zipCode || zipCode.trim() === '') newErrors.zipCode = true;
        if (!productType) newErrors.productType = true;

        setValidationErrors(newErrors);

        return Object.keys(newErrors).length === 0; // true if no errors
    };

    useEffect(() => {
        if (supplierRegisterationResponse?.status === true) {
            dispatch(registerSupplierStateReset());
            showSuccessToast(supplierRegisterationResponse?.message);
            clearForm();
            if (modalRef.current) {
                const modalInstance = window.bootstrap.Modal.getInstance(modalRef.current); // get existing instance
                if (modalInstance) {
                    modalInstance.hide();
                }
            }
        }
    }, [supplierRegisterationResponse])

    useEffect(() => {
        if (supplierRegisterationError) {
            showErrorToast(supplierRegisterationError?.data);
        }
    }, [supplierRegisterationResponse])
    return (
        <>
            {
                loading
                    ? (
                        <div
                            style={{ height: "70vh" }}
                            className="d-flex align-items-center justify-content-center"
                        >
                            <PulseLoader size={25} color="#0f0a30" />
                        </div>
                    ) : error ? (
                        <div
                            style={{ height: "70vh" }}
                            className="d-flex align-items-center justify-content-center"
                        >
                            <p className="text-danger">Something went wrong</p>
                        </div>
                    ) : (
                        <Table
                            title='Suppliers'
                            tableData={response?.data}
                            limit={limit}
                            items={items}
                            columns={columns}
                            totalPages={totalPages}
                            currentPage={currentPage}
                            handlePageChange={handlePageChange}
                            role='supplier'
                            statusTerm={statusTerm}
                        />

                    )}
            <div className="modal fade" id="addSupplierModal" tabIndex={-1} aria-labelledby="addSupplierModalLabel" aria-hidden="true" ref={modalRef}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-2 fw-bold text-black" id="addSupplierModalLabel">Add New Supplier</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => clearForm()} />
                        </div>
                        <div className="modal-body detail-modal-body">
                            <div className='modal-field mb-2'>

                                <div className="input_wrapper">
                                    <label>First Name</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.firstName ? 'is-invalid' : ''}`}
                                            placeholder="Enter name"
                                            value={firstName}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.length === 1 && value === ' ') return;
                                                setFirstName(value);
                                                if (validationErrors.firstName) {
                                                    setValidationErrors(prev => ({ ...prev, firstName: false }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="input_wrapper">
                                    <label>Last Name</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.lastName ? 'is-invalid' : ''}`}
                                            placeholder="Enter name"
                                            value={lastName}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.length === 1 && value === ' ') return;
                                                setLastName(value);
                                                if (validationErrors.lastName) {
                                                    setValidationErrors(prev => ({ ...prev, lastName: false }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="input_wrapper">
                                    <label>Phone Number</label>
                                    <PhoneInput
                                        country={'in'} // default country
                                        value={phoneNumber}
                                        onChange={(value) => {
                                            setPhoneNumber(value);

                                            // validation
                                            if (!value || value.length < 10) {
                                                setValidationErrors(prev => ({ ...prev, phone: true }));
                                            } else {
                                                setValidationErrors(prev => ({ ...prev, phone: false }));
                                            }
                                        }}
                                        inputStyle={{ width: "100%" }}
                                        containerClass={`form-control ${validationErrors.phone ? "is-invalid" : ""}`}
                                    />
                                </div>
                                <div className="input_wrapper">
                                    <label>Email Address</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.email ? 'is-invalid' : ''}`}
                                            placeholder="Enter name"
                                            value={email}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.length === 1 && value === ' ') return;
                                                setEmail(value);
                                                if (validationErrors.email) {
                                                    setValidationErrors(prev => ({ ...prev, email: false }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="input_wrapper">
                                    <label>Country</label>
                                    <div className={`form-control ${validationErrors.state ? 'is-invalid' : ''}`}>
                                        <CountrySelect
                                            onChange={(e) => {
                                                setCountry(e.id);
                                                setCountryName(e.name);
                                                if (validationErrors.country) {
                                                    setValidationErrors(prev => ({ ...prev, country: false }));
                                                }
                                            }}
                                            placeHolder="Select Country"
                                            className={`form-control ${validationErrors.country ? 'is-invalid' : ''}`}
                                        />
                                    </div>
                                </div>

                                <div className="input_wrapper">
                                    <label>State</label>
                                    <div className={`form-control ${validationErrors.state ? 'is-invalid' : ''}`}>
                                        <StateSelect
                                            countryid={country}
                                            onChange={(e) => {
                                                setState(e.id);
                                                setStateName(e.name);
                                                if (validationErrors.state) {
                                                    setValidationErrors(prev => ({ ...prev, state: false }));
                                                }
                                            }}
                                            placeHolder="Select State"
                                            className={`form-control ${validationErrors.state ? 'is-invalid' : ''}`}
                                        />
                                    </div>
                                </div>

                                <div className="input_wrapper">
                                    <label>City</label>
                                    <div className={`form-control ${validationErrors.state ? 'is-invalid' : ''}`}>
                                        <CitySelect
                                            countryid={country}
                                            stateid={state}
                                            onChange={(e) => {
                                                setCity(e.id);
                                                setCityName(e.name);
                                                if (validationErrors.city) {
                                                    setValidationErrors(prev => ({ ...prev, city: false }));
                                                }
                                            }}
                                            placeHolder="Select City"
                                            className={`form-control ${validationErrors.city ? 'is-invalid' : ''}`}
                                        />
                                    </div>
                                </div>

                                <div className="input_wrapper">
                                    <label>Street Address</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.streetAddress ? 'is-invalid' : ''}`}
                                            placeholder="Enter name"
                                            value={streetAddress}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.length === 1 && value === ' ') return;
                                                setStreetAddress(value);
                                                if (validationErrors.streetAddress) {
                                                    setValidationErrors(prev => ({ ...prev, streetAddress: false }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="input_wrapper">
                                    <label>Zip Code</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.zipCode ? 'is-invalid' : ''}`}
                                            placeholder="Enter name"
                                            value={zipCode}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.length === 1 && value === ' ') return;
                                                setZipCode(value);
                                                if (validationErrors.zipCode) {
                                                    setValidationErrors(prev => ({ ...prev, zipCode: false }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="input_wrapper">
                                    <label>Type of Product supplier will sell</label>
                                    <div className="form_field">
                                        <select
                                            className={`form-control ${validationErrors.productType ? 'is-invalid' : ''}`}
                                            value={productType}
                                            onChange={(e) => {
                                                setProductType(e.target.value);
                                                if (validationErrors.productType) {
                                                    setValidationErrors((prev) => ({ ...prev, productType: false }));
                                                }
                                            }}
                                        >
                                            {productTypeLoading ? (
                                                <option value="">Loading...</option>
                                            ) : productTypeError ? (
                                                <option value="">No data</option>
                                            ) : (
                                                <>
                                                    <option value="">-- Select Product Type --</option>
                                                    {productTypeResponse?.data?.productType?.map((type) => (
                                                        <option key={type._id} value={type._id}>
                                                            {type.name}
                                                        </option>
                                                    ))}
                                                </>
                                            )}
                                        </select>
                                    </div>
                                </div>



                            </div>
                            <div className='modal_btn d-flex justify-content-end gap-2 p-0 mt-4'>
                                <button className='transparent-btn fs-14 py-2' data-bs-dismiss="modal">Cancel</button>
                                <button className='primary-btn fs-14 py-2' onClick={handleAddNewSupplier}>{supplierRegisterationLoading ? <PulseLoader color="#ffffff" size={12} /> : 'Add New'}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default SupplierManagement